import React from 'react';
import { motion } from 'framer-motion';
import './FormContainer.css';


const FormContainer = ({
  borderRadius = '20px',
  padding = '40px',
  backgroundColor = '#fff',
  children,
}) => {
  const style = { borderRadius, padding, backgroundColor };

  return (
    <motion.div
      className="form-container"
      style={style}
      initial={{ x: -50, opacity: 0 }}
      animate={{
        x: 0,
        opacity: 1,
        transition: { type: 'spring', stiffness: 200, damping: 20 }
      }}
      exit={{
        x: 50,
        opacity: 0,
        transition: { duration: 0.2, ease: 'easeIn' }
      }}
    >
      {children}
    </motion.div>
  );
};

export default FormContainer;

